import React, { useEffect } from 'react';
import './legal.css';

const LegalPage = ({ title, htmlContent }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-wrapper">
      <div className="legal-container">
        {/* Header de la page */}
        <header className="legal-header">
          <h1 className="legal-title">{title}</h1>
          <p className="legal-date">
            Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>
        </header>

        {/* Content */}
        <main
          className="legal-content"
          dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
      </div>
    </div>
  );
};

export default LegalPage;